import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-enough-credit',
  templateUrl: './not-enough-credit.component.html',
  styleUrls: ['./not-enough-credit.component.css'],
  standalone: true,
  imports: [RouterModule],
})
export class NotEnoughCreditComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<NotEnoughCreditComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
